<div class="card mb-3">
  <div class="card-body">
    <h1>Facilities</h1>
    <div id="water-system-facilities">
      <div>
        <app-flow-visualization></app-flow-visualization>
      </div>
    </div>
  </div>
</div>